<div class="p-d-flex p-flex-column p-p-2">
	<div
		class="p-d-flex p-ai-center p-mb-2 p-pb-2"
		style="border-bottom: 1px solid var(--surface-d)"
		*ngIf="name"
	>
		<p-avatar
			[image]="imageUrl"
			[label]="!imageUrl && !icon ? name.charAt(0).toUpperCase() : null"
			[icon]="icon ? icon : null"
			shape="circle"
			[style]="{
        'background-color': !imageUrl && !icon ? '#c9ffa97d' : 'transparent',
      }"
			class="p-mr-2"
		></p-avatar>
		<span class="p-text-bold">{{ name }}</span>
	</div>

	<div
		*ngIf="text"
		class="p-mb-2"
		style="white-space: pre-line"
	>
		{{ text }}
	</div>

	<div
		*ngIf="eventsCount !== null"
		class="p-d-flex p-ai-center p-mb-1"
	>
		<i class="pi pi-calendar p-mr-2"></i>
		<span>
			<span class="p-text-bold">{{ eventsCount }}</span>
			{{ panelType === 'right' ? 'other jobs' : 'jobs' }}
		</span>
	</div>

	<div
		*ngIf="revenue !== null"
		class="p-d-flex p-ai-center"
	>
		<i class="pi pi-dollar p-mr-2"></i>
		<span>
			Revenue:
			<span class="p-text-bold">
				{{ revenue | freyaCurrency: 'CAD' }}
			</span>
		</span>
	</div>
</div>